import { MasteryPacing } from "@/enums";

// Types based on the provided schema
export type StandardsMetadataType = {
  standardId: string;
  description?: string;
  state?: string;
  standardCategory?: string;
  strand?: string;
  grade?: string;
  standardAbbrv?: string;
  weight?: number;
}

export type MasteryRecordType = {
  studentId: string;
  skillId: string;
  errorCount?: number;
  exposureCount?: number;
  locale?: string;
  mastery: number;
  pacing?: string;
  updatedAt: string;
}

export type StandardMasterySkillType = {
  skillId: string;
  masteryRecords: MasteryRecordType[];
}

export type StandardMasteryReportType = {
  standardId: string;
  averageMastery?: number;
  aggregatePacing?: MasteryPacing;
  totalMasteryRecords?: number;
  skills: StandardMasterySkillType[];
}

// New types for StandardSkills query
export type SkillSummaryType = {
  skillId: string;
  skillName?: string;
}

export type StandardSummaryType = {
  standardId: string;
  description?: string;
}

export type StandardSkillsType = {
  standard: StandardSummaryType;
  skills: SkillSummaryType[];
}

export type UnitMasteryReport = {
  unitId: string;
  averageMastery?: number;
  totalMasteryRecords?: number;
}

// GraphQL Queries
export const GET_STANDARDS_METADATA = `
  query GetStandardsMetadata($standardSet: String!, $grade: String) {
    getStandardsMetadata(standardSet: $standardSet, grade: $grade) {
      standardId
      description
      state
      standardCategory
      strand
      grade
      standardAbbrv
      weight
    }
  }
`;

export const GET_MASTERY_BY_STANDARD = `
  query GetMasteryByStandard($standardId: [ID!]!, $studentId: [ID!]!, $dateFrom: AWSDate, $dateTo: AWSDate) {
    getMasteryByStandard(standardId: $standardId, studentId: $studentId, dateFrom: $dateFrom, dateTo: $dateTo) {
      standardId
      averageMastery
      aggregatePacing
      totalMasteryRecords
      skills {
        skillId
        masteryRecords {
          studentId
          skillId
          errorCount
          exposureCount
          locale
          mastery
          pacing
          updatedAt
        }
      }
    }
  }
`;

export const GET_STANDARD_SKILLS = `
  query GetStandardSkills($standardId: [ID!]!) {
    getStandardSkills(standardId: $standardId) {
      skills {
        skillId
        skillName
      }
      standard {
        description
        standardId
      }
    }
  }
`;

export const GET_MASTERY_BY_UNIT = `
  query GetMasteryByUnit($unitId: [ID!]!, $studentId: [ID!]!, $dateFrom: AWSDate, $dateTo: AWSDate) {
    getMasteryByUnit(unitId: $unitId, studentId: $studentId, dateFrom: $dateFrom, dateTo: $dateTo) {
      unitId
      averageMastery
      totalMasteryRecords
    }
  }
`;
